import {
    PlanCreateParams,
    PlanUpdateParams,
    PlanListResponse,
    PlanQuery,
    PlanData,
    OptimalPlanQuery,
    PlanResponse,
    OptimalPlanResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/plan';

export class PlanApi {
    public static async create(plan: PlanCreateParams): Promise<void> {
        await axios.post(`${BASE_URL}`, { plan });
    }

    public static async update(id: string, plan: PlanUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { plan });
    }

    public static async getPlan(id: string): Promise<PlanData> {
        const res = await axios.get<PlanResponse>(`${BASE_URL}/${id}`);

        return res.data.plan;
    }

    public static async getList(params?: PlanQuery): Promise<PlanListResponse> {
        const res = await axios.get<PlanListResponse>(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async getOptimalPlans(params: OptimalPlanQuery): Promise<OptimalPlanResponse> {
        const res = await axios.get<OptimalPlanResponse>(`${BASE_URL}/optimal`, { params });

        return res.data;
    }

    public static async setPlanService(id: string, serviceId: string): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/service`, { serviceId });
    }

    public static async removePlanService(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/service`);
    }
}
